/**
 * Shared timeline display filters (frontend-safe — no zod, no service imports).
 *
 * Lifecycle "Email Delivered: …" tasks are auto-generated marketing sends that
 * flood the timeline (~7.9M in SFDC); they're excluded from the account and
 * contact timeline views. Undated entries are excluded separately per-timeline
 * (the "undated" concept differs: a null date vs. the account timeline's
 * server-computed `undated` bucket).
 *
 * Core imports this directly (backend via relative path, frontend via
 * `@shared/flow/timeline-filter`). Mini-apps can't import core, so action-view
 * keeps a matching local copy — keep them in sync.
 */
export const LIFECYCLE_EMAIL_SUBJECT_PREFIX = 'Email Delivered';

export function isLifecycleEmailSubject(subject: string | null | undefined): boolean {
  return !!subject && subject.startsWith(LIFECYCLE_EMAIL_SUBJECT_PREFIX);
}
